<div class="row" *ngIf="messageService.exceptionMessages.length > 0">
    <div class="alert alert-danger" role="alert">
        <h5 style="margin-left:20px;">APN QuickSearch System Error</h5>
        <hr />
        <ul>
            <li *ngFor="let msg of messageService.exceptionMessages">
              <strong>{{msg}}</strong>
            </li>
        </ul>
        <hr />
        <button mat-raised-button (click)="closeNotices()">Close</button>
      </div>
</div>


